// src/components/AchievementsModal.js
import React, { useState, useEffect } from 'react';
import pointsIcon from '../assets/points_icon.png';

const AutoIcon = () => (
  <svg className="type-icon auto" viewBox="0 0 24 24" title="Начисляется автоматически">
    <path fill="currentColor" d="M12,2A2,2 0 0,1 14,4C14,4.74 13.6,5.39 13,5.73V7H14A7,7 0 0,1 21,14H22A1,1 0 0,1 23,15V18A1,1 0 0,1 22,19H21V21A1,1 0 0,1 20,22H4A1,1 0 0,1 3,21V19H2A1,1 0 0,1 1,18V15A1,1 0 0,1 2,14H3A7,7 0 0,1 10,7H11V5.73C10.4,5.39 10,4.74 10,4A2,2 0 0,1 12,2M7.5,13A2.5,2.5 0 0,0 5,15.5A2.5,2.5 0 0,0 7.5,18A2.5,2.5 0 0,0 10,15.5A2.5,2.5 0 0,0 7.5,13M16.5,13A2.5,2.5 0 0,0 14,15.5A2.5,2.5 0 0,0 16.5,18A2.5,2.5 0 0,0 19,15.5A2.5,2.5 0 0,0 16.5,13Z" />
  </svg>
);

// Иконка человека/админа (Вручную)
const ManualIcon = () => (
  <svg className="type-icon manual" viewBox="0 0 24 24" title="Выдается администратором">
    <path fill="currentColor" d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z" />
  </svg>
);

export default function AchievementsModal() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Загружаем наш JSON-файл. Он будет доступен по корневому URL.
    fetch('/achievements.json')
      .then(response => response.json())
      .then(jsonData => {
        setData(jsonData);
        setLoading(false);
      })
      .catch(error => {
        console.error("Не удалось загрузить achievements.json:", error);
        setLoading(false);
      });
  }, []); // Пустой массив зависимостей означает, что эффект выполнится один раз

  if (loading) {
    return <p>Загрузка справки...</p>;
  }

  if (!data) {
    return <p>Не удалось загрузить информацию. Попробуйте позже.</p>;
  }

  return (
    <div className="achievements-modal">
      <h2>Как получить очки?</h2>
      {/* Используем dangerouslySetInnerHTML, чтобы отрендерить HTML-теги из описания */}
      <p className="achievements-desc" dangerouslySetInnerHTML={{ __html: data.description }}></p>
      
      {data.categories.map(category => (
        <div key={category.name} className="achievements-category">
          <h3>{category.name}</h3>
          <ul className="achievements-list">
            {category.achievements.map((ach, index) => (
              <li key={index} className="achievement-item">
                <div className="achievement-info">
                  {/* --- НОВОЕ: Иконка типа --- */}
                  {ach.type === 'auto' ? <AutoIcon /> : <ManualIcon />}
                  <span className="achievement-desc">{ach.description}</span>
                </div>
                <span className={`achievement-points ${ach.points > 0 || typeof(ach.points) !== "number" ? 'positive' : 'negative'}`}>
                  {ach.points} <img src={pointsIcon} alt="points" className="points-icon seasonal-icon" />
                </span>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}